var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2905 15.29L14.0005 14V9C14.0005 5.93 12.3605 3.36 9.50054 2.68V2C9.50054 1.17 8.83054 0.5 8.00054 0.5C7.17054 0.5 6.50054 1.17 6.50054 2V2.68C3.63054 3.36 2.00054 5.92 2.00054 9V14L0.71054 15.29C0.0805397 15.92 0.52054 17 1.41054 17H14.5805C15.4805 17 15.9205 15.92 15.2905 15.29ZM12.0005 15H4.00054V9C4.00054 6.52 5.51054 4.5 8.00054 4.5C10.4905 4.5 12.0005 6.52 12.0005 9V15ZM8.00054 20C9.10054 20 10.0005 19.1 10.0005 18H6.00054C6.00054 19.1 6.89054 20 8.00054 20Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications_icon.68fdedb5aca6fc17589ae4a53f5c36a5.svg";
export { ForwardRef as ReactComponent };